'use client';
import type { FC } from 'react';
import { useRef, useMemo } from 'react';
import { ShareActionsheet } from '@app/_components/share-actionsheet';
import { css } from '@styled-system/css';
import { cva } from '@styled-system/css';
import shareDarkImage from './assets/share-dark.svg';
import shareLightImage from './assets/share-light.svg';
import { useLocalHooks } from './use-local-hooks';
interface Props {
  text: string;
  url: string;
  hashtags?: ReadonlyArray<string>;
  dark?: boolean;
}

export const ShareActionsheetWithLink: FC<Props> = ({
  text,
  url,
  dark,
  hashtags,
}) => {
  const urlInputRef = useRef<HTMLInputElement>(null);

  const src = useMemo(() => {
    return dark ? shareDarkImage : shareLightImage;
  }, [dark]);

  const { isOpen, open, close } = useLocalHooks({
    text,
    url,
    hashtags,
    urlInputRef,
  });

  return (
    <>
      <div
        onClick={open}
        className={shareLinkStyle({
          visual: dark ? 'dark' : 'bright',
        })}
      >
        <img
          src={src}
          className={css({
            marginRight: '4px',
          })}
          alt="シェアする"
        />
        <span>シェアする</span>
      </div>

      <ShareActionsheet
        isOpen={isOpen || false}
        onClose={close}
        text={text}
        url={url}
        hashtags={hashtags}
      />
    </>
  );
};

const shareLinkStyle = cva({
  base: {
    display: 'flex',
    alignItems: 'center',
    fontSize: 'size_14',
    textAlign: 'center',
    padding: '10px 10px',
    cursor: 'pointer',
    fontWeight: 'bold',
  },
  variants: {
    visual: {
      dark: {
        background: 'grey_transparent',
        color: 'primary',
      },
      bright: {
        color: 'tint',
      },
    },
  },
});
